export const filterFalsy = (obj) =>
  Object.fromEntries(Object.entries(obj).filter(([k, v]) => v));
